<template>
  <d-row class="navbar navbar-top bg-white no-gutters align-content-center justify-content-center">
    <d-col cols="10">
      <d-row class="align-items-center justify-content-end">
        <d-col cols="auto">
          <div>
            <locale-select />
          </div>
        </d-col>
      </d-row>
    </d-col>
  </d-row>
</template>

<script>
import LocaleSelect from '@/components/common/LocaleSelect';

export default {
  name: 'navbar',
  components: { LocaleSelect },
};
</script>
